import { ErrorBoundary, useTheme } from "@privemind/components";
import { Navigation } from "./components/navigation/navigation";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { HomeObserver } from "./observers/home-observer";
import { EditAssetsObserver } from "./observers/edit-assets-observer";
import { BucketDetail } from "./components/bucket-detail/bucket-detail";
import { StatsObserver } from "./observers/stats-observer";

export const AppContent: React.FC = () => {
  const theme = useTheme();

  return (
    <BrowserRouter>
      <div 
        className="app"
        style={{
          backgroundColor: theme.colors.background.normal,
          color: theme.colors.background.contrast,
        }}
      >
        <div 
          className="app__header"
          style={{
            borderBottomColor: theme.colors.secondary.dark,
          }}
        >
          <h1 style={{ color: theme.colors.background.contrast }}>
            <img src="/logo.png" alt="Crypto Portfolio Tracker" style={{ height: '48px', marginRight: '12px', verticalAlign: 'middle' }} />
            Crypto Portfolio Tracker
          </h1>
        </div>
        
        <Navigation />
        
        <main className="app__content">
          <ErrorBoundary>
            <Routes>
              <Route path="/" element={
                <ErrorBoundary>
                  <HomeObserver />
                </ErrorBoundary>
              } />
              <Route path="/edit-assets" element={
                <ErrorBoundary>
                  <EditAssetsObserver />
                </ErrorBoundary>
              } />
              <Route path="/edit-assets/bucket/:bucketName" element={
                <ErrorBoundary>
                  <BucketDetail />
                </ErrorBoundary>
              } />
              <Route path="/stats" element={
                <ErrorBoundary>
                  <StatsObserver />
                </ErrorBoundary>
              } />
            </Routes>
          </ErrorBoundary>
        </main>
      </div>
    </BrowserRouter>
  );
};
